<template>
  <el-dialog
    width="880px"
    top="60px"
    custom-class="tpl-upload-modal"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :show-close="false"
    @closed="handleVisible"
  >
    <div class="modal-wrapper">
      <div class="upload-box">
        <upload-drag-box @add="handleAddFiles" class="upload-main">
          <div
            class="c-center"
            :style="{
              height: psdParseState === 'upload' ? 'auto' : 0
            }"
          >
            <div class="upload-box-title" v-show="psdParseState === 'upload'">
              将文件拖放到这里
            </div>
            <div v-show="psdParseState === 'upload'">或者</div>
            <psd-parse
              ref="psdParse"
              @onCompleted="onParsingCompleted"
              @onFileChange="handlePsdParsing"
              :isFree="!!(uploadForm.type === 'free')"
            >
              <el-button
                type="primary"
                ref="uploadBtn"
                v-show="psdParseState === 'upload'"
                >选择文件</el-button
              >
            </psd-parse>
          </div>
          <div v-show="psdParseState === 'loading'" class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
            <br />
            解析中...
          </div>
          <!-- <el-image
            v-show="psdParseState === 'preview'"
            style="width: 100%; height: 100%"
            :src="template.defaultUrl"
            fit="contain"
          >
          </el-image> -->
          <!-- <free-editor
            v-show="psdParseState === 'preview'"
            v-if="newTemplate.json.children"
            v-model="newTemplate.json"
            class="upload-preview"
            :preview="true"
            :edit="false"
            :scale="calcMenuScale(newTemplate)"
          ></free-editor> -->
          <editor-area
            v-model="previewTemplate.json"
            v-show="psdParseState === 'preview'"
            v-if="previewTemplate.json.children"
            class="upload-preview"
            :preview="true"
            :edit="false"
            :scale="calcMenuScale(previewTemplate)"
          ></editor-area>
        </upload-drag-box>
      </div>
      <div class="upload-form">
        <div class="form-title">上传图片模板</div>
        <el-form ref="uploadForm" :model="uploadForm" class="form-cont">
          <el-form-item>
            <div class="form-label">
              所属项目 <span>{{ prjAuth ? '' : '（该项目无上传权限）' }}</span>
            </div>
            <el-select
              v-model="uploadForm.projectId"
              size="large"
              placeholder="请选择所属项目"
              @change="handlePrjChange"
            >
              <el-option
                v-for="prj in projects"
                :key="prj.id"
                :label="prj.name"
                :value="prj.id"
                :class="{ sub: prj.role !== 'PROJ_ADMIN' }"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="form-label">
              模板类型
              <span>{{
                typeAuth
                  ? ''
                  : `（该项目不允许上传${
                      uploadForm.type === 'free'
                        ? '自由'
                        : uploadForm.type === 'fixed'
                        ? '固定'
                        : ''
                    }模板）`
              }}</span>
            </div>
            <el-select
              v-model="uploadForm.type"
              size="large"
              placeholder="请选择模板类型"
            >
              <el-option
                label="自由模板"
                value="free"
                :class="{ sub: !freeAuth }"
                >自由模板</el-option
              >
              <el-option
                label="固定模板"
                value="fixed"
                :class="{ sub: !fixedAuth }"
                >固定模板</el-option
              >
            </el-select>
            <div
              class="form-tips"
              v-html="
                uploadForm.type === 'free'
                  ? '模板上的文字、素材可任意编辑，用户可以自由调整，自由创作'
                  : '模板上的文字、素材限制编辑，用户只能改文字内容，替换图片<br/>仅适合对图片使用有严格规范的项目'
              "
            ></div>
          </el-form-item>
          <el-form-item>
            <div class="form-label">模板要求</div>
            <div>
              查看&nbsp;<a
                href="https://docs.popo.netease.com/lingxi/901199e2e35547848457d6805e259835"
                target="_blank"
                >模板要求规范</a
              >
            </div>
          </el-form-item>
        </el-form>
        <div class="form-btns">
          <el-button
            round
            :disabled="!(canUpload && psdParseState === 'preview')"
            @click="handleTplEdit"
            >{{ isMissingFonts ? 'A?' : '' }} 去编辑模板</el-button
          >
          <el-button
            type="primary"
            round
            :disabled="!(canUpload && psdParseState === 'preview')"
            :loading="uploadLoading"
            @click="handleSave"
            >直接上传</el-button
          >
        </div>
      </div>
      <i class="el-icon-close" @click="dialogVisible = false"></i>
    </div>
    <attr-dialog
      ref="attrDialog"
      v-model="attrDialogVisible"
      :show="attrDialogVisible"
      :data="newTemplate"
      :isNew="true"
      @onSave="onCompleted"
    ></attr-dialog>
  </el-dialog>
</template>
<script>
import uploadService from '@/request/service/fileupload-service'
import templateService from '@/request/service/template-service'
import fontService from '@/request/service/font-service'
// import freeEditor from '@/views/templateFree/free-editor'
import EditorArea from '@/views/templateGroup/editor/tpl-editor-area'
import attrDialog from '@/views/components/attr-dialog/attr-dialog'
import PsdParse from './psd-parse/index.vue'
import util from '@/util.js';
import UploadDragBox from './psd-parse/upload-drag-box.vue'
import { empty_template } from '@/const.js'
import { mapGetters } from 'vuex'
export default {
  components: {
    attrDialog,
    UploadDragBox,
    PsdParse,
    EditorArea
    // freeEditor
    // PsdParse
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      attrDialogVisible: false,
      psdParseState: 'upload',
      template: JSON.parse(JSON.stringify(empty_template)),
      previewTemplate: JSON.parse(JSON.stringify(empty_template)),
      newTemplate: JSON.parse(JSON.stringify(empty_template)),
      uploadLoading: false,
      isMissingFonts: false,
      uploadForm: {
        type: 'free',
        projectId: ''
      },
      allFileList: []
    }
  },
  computed: {
    ...mapGetters({
      projectId: 'app/projectId',
      projects: 'app/projects'
    }),
    // projectId () {
    //   return this.$store.state.app.projectId
    // },
    // projects () {
    //   return this.$store.state.app.loginUser.projectItems
    // },
    allSize () {
      return this.allFileList.reduce((total, item) => {
        return total + item.size
      }, 0)
    },
    prjAuth () {
      const selectPrjId = this.uploadForm.projectId
      const selectPrj = this.projects
        ? this.projects.filter(item => item.id === selectPrjId)[0]
        : null
      return selectPrj && selectPrj.role === 'PROJ_ADMIN'
    },
    typeAuth () {
      const selectPrjId = this.uploadForm.projectId
      const selectPrj = this.projects
        ? this.projects.filter(item => item.id === selectPrjId)[0]
        : null
      return (
        selectPrj &&
        ((this.uploadForm.type === 'free' &&
          selectPrj.settings &&
          selectPrj.settings.UPLOAD_FREE_TEMPLATE === 'ON') ||
          (this.uploadForm.type === 'fixed' &&
            selectPrj.settings &&
            selectPrj.settings.UPLOAD_FIXED_TEMPLATE === 'ON'))
      )
    },
    canUpload () {
      return this.prjAuth && this.typeAuth
    },
    freeAuth () {
      const selectPrjId = this.uploadForm.projectId
      const selectPrj = this.projects
        ? this.projects.filter(item => item.id === selectPrjId)[0]
        : null
      return (
        selectPrj &&
        selectPrj.settings &&
        selectPrj.settings.UPLOAD_FREE_TEMPLATE === 'ON'
      )
    },
    fixedAuth () {
      const selectPrjId = this.uploadForm.projectId
      const selectPrj = this.projects
        ? this.projects.filter(item => item.id === selectPrjId)[0]
        : null
      return (
        selectPrj &&
        selectPrj.settings &&
        selectPrj.settings.UPLOAD_FIXED_TEMPLATE === 'ON'
      )
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
      if (val) {
        this.initData()
      } else {
        this.dialogVisible = false
        this.psdParseState = 'upload'
      }
    }
  },
  methods: {
    initData () {
      this.uploadLoading = false
      this.uploadForm.projectId = this.projectId
      this.missingFontsList = []
      this.recommendFontsList = []
      this.isMissingFonts = false
      this.uploadForm.type = this.freeAuth ? 'free' : this.fixedAuth ? 'fixed' : 'free'
    },
    calcMenuScale(template){
      let {width, height, scale = 1} = template.json;
      return util.getScaleWidthAndHeight(518, 552, width, height) / scale;
    },
    handleAddFiles (files) {
      if (files.length > 1) {
        return this.$message.error('一次只能传一张模板')
      } else if (!files[0].name.toLowerCase().endsWith('.psd')) {
        return this.$message.error('只能传psd格式的模板')
      } else {
        const file = {
          raw: files[0],
          name: files[0].name
        }
        this.$refs.psdParse.onFileChange(file)
      }
    },
    // --------- psd解析方法 start-----
    handlePsdParsing () {
      this.psdParseState = 'loading'
    },
    onParsingCompleted (psdData) {
      this.template = JSON.parse(JSON.stringify(psdData))
      uploadService
        .uploadFileByBase64(this.template.defaultUrl)
        .then(urlData => {
          this.template.defaultUrl = urlData.url
          if (this.template.name.length > 20) {
            this.template.name = this.template.name.substring(0, 20)
          }
          this.psdParseState = 'preview'
          this.initTpl()
        })
        .catch(error => {
          this.$message.error(error)
          this.psdParseState = 'upload'
        })
      // this.saveTemplate()
    },
    handleSave () {
      this.replaceTemplateFontsAll(this.template.json, this.recommendFontsList)
      console.log(123, this.template.json)
      const params = {
        ...this.template,
        type: 'MULTIPLE',
        isFree: this.uploadForm.type === 'free',
        projectId: this.uploadForm.projectId
      }
      this.uploadLoading = true
      templateService
        .saveTemplatev2(params)
        .then(d => {
          this.dialogVisible = false
          this.$emit('success', this.uploadForm.projectId)
        })
        .finally(() => {
          this.uploadLoading = false
        })
    },
    initTpl () {
      this.$store.dispatch(
        'app/queryTemplateTagList',
        this.uploadForm.projectId
      )
      this.newTemplate = {
        ...this.template,
        tplGroupName: '',
        tplGroupId: '',
        type: 'MULTIPLE',
        isFree: this.uploadForm.type === 'free',
        projectId: this.uploadForm.projectId
      }
      this.initPreviewTemplate()
    },
    initPreviewTemplate () {
      this.previewTemplate = JSON.parse(JSON.stringify(this.newTemplate))
      const _allFontFamily = []
      const mapTpl = (item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            if (child.type === 'text' && child.fontFamily) {
              _allFontFamily.push(child.fontFamily)
            }
            mapTpl(child)
          })
        } else {
          return
        }
      }
      mapTpl(this.previewTemplate.json)
      this.allFontFamily = [...new Set(_allFontFamily)]
      this.allFontFamily && this.isMissingFont()
      // console.log(111111, this.previewTemplate)
    },
    isMissingFont () {
      this.allFontFamily && this.allFontFamily.length > 0 && fontService.getFontListByNames(
        this.uploadForm.projectId,
        [...this.allFontFamily]
      ).then(res => {
        const prjFontsList = res.map(item => item.psName)
        this.isMissingFonts = !(this.allFontFamily.every(item => prjFontsList.includes(item)))
        this.replaceFonts(prjFontsList)
      })
    },
    replaceFonts (prjFontsList) {
      let _missingFontsList = []
      const mapTpl = (item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            if (child.type === 'text' && child.fontFamily) {
              if (!prjFontsList.includes(child.beforeFontFamily || child.fontFamily)) {
                _missingFontsList.push(child.beforeFontFamily || child.fontFamily)
                !(child.beforeFontFamily) && (child.beforeFontFamily = child.fontFamily)
                // _missingFontsList.push(child.beforeFontFamily || child.fontFamily)
              }
            }
            mapTpl(child)
          })
        } else {
          return
        }
      }
      mapTpl(this.previewTemplate.json)
      this.missingFontsList = [...new Set(_missingFontsList)]
      // console.log(0, _missingFontsList, this.missingFontsList)
      fontService.getRecommendFonts({
        names: this.missingFontsList.join(','),
        projectId: this.uploadForm.projectId
      }).then(data => {
        this.recommendFontsList = data
        this.replaceFontsAll(this.previewTemplate.json, this.recommendFontsList)
      })
    },
    replaceFontsAll (remplageJson, recommendFontsList) {
      const mapTpl = (item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            if (child.type === 'text' && child.beforeFontFamily) {
              child.fontFamily = recommendFontsList.find(item => item.missingFont === child.beforeFontFamily).recPsName
            }
            mapTpl(child)
          })
        } else {
          return
        }
      }
      mapTpl(remplageJson)
    },
    replaceTemplateFontsAll (remplageJson, recommendFontsList) {
      const mapTpl = (item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            if (child.type === 'text' && recommendFontsList.find(item => item.missingFont === child.fontFamily)) {
              child.fontFamily = recommendFontsList.find(item => item.missingFont === child.fontFamily).recPsName
            }
            mapTpl(child)
          })
        } else {
          return
        }
      }
      mapTpl(remplageJson)
    },
    handleTplEdit () {
      this.newTemplate.projectId = this.uploadForm.projectId
      this.attrDialogVisible = true
      // this.dialogVisible = false
    },
    onCompleted () {
      this.attrDialogVisible = false
      this.dialogVisible = false
      this.$emit('success', this.uploadForm.projectId)
    },
    // --------- psd解析方法 end -----
    handlePrjChange (val) {
      this.uploadForm.projectId = val
      this.uploadForm.type = this.freeAuth ? 'free' : this.fixedAuth ? 'fixed' : 'free'
      this.isMissingFont()
    },
    handleVisible (val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.tpl-upload-modal {
  border-radius: 8px;
  .modal-wrapper {
    position: relative;
    display: flex;
    height: 586px;
    .el-icon-close {
      position: absolute;
      right: -4px;
      top: -4px;
      font-size: 20px;
      font-weight: 600;
      color: #2e3138;
      cursor: pointer;
    }
    .upload-box {
      width: 552px;
      padding: 16px;
      margin-right: 16px;
      border-radius: 4px;
      border: 1px dashed #d5d7dd;
      .upload-main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .upload-box-title {
          line-height: 1.2;
          font-size: 16px;
          font-weight: 600;
          color: #2e3138;
        }
        .el-loading-spinner {
          font-weight: 600;
          font-size: 16px;
          line-height: 1.8;
          color: #2e3138;
        }
      }
      .upload-preview {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        // &>.right-menu>div {
        //   margin: auto;
        // }
      }
    }
    .upload-form {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 0;
      line-height: 1.2;
      :deep(.el-select) {
        width: 100%;
      }
      .form-title {
        margin-top: -4px;
        font-weight: 600;
        font-size: 18px;
        color: #2e3138;
      }
      .form-cont {
        flex: 1;
        margin-top: 28px;
        color: #323337;
        .form-label {
          margin-bottom: 8px;
          font-weight: 500;
          font-size: 14px;
          line-height: 1.2;
          color: #2e3138;
          span {
            color: #f52222;
            font-weight: 400;
          }
        }
        .form-tips {
          padding: 8px;
          margin-top: 8px;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #898a8e;
          background: #f2f2f2;
          border-radius: 4px;
        }
        a {
          text-decoration: underline;
        }
      }
      .form-btns {
        height: auto;
        text-align: right;
      }
    }
  }
}
.sub {
  color: #bcbdc0 !important;
}
.el-select-dropdown__item.selected.sub {
  color: #3366FF !important;
}
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 16px;
}
</style>
